import { tv } from "tailwind-variants";

const overlayStyles = tv({
  base: [
    "fixed inset-0 z-50 flex items-center justify-center",
    "bg-bg/80 backdrop-blur-sm",
    "animate-in fade-in duration-200",
  ],
});

const spinnerStyles = tv({
  base: [
    "size-10 animate-spin rounded-full",
    "border-4 border-muted-fg/20 border-t-primary",
  ],
});

export interface LoadingOverlayProps {
  /** The loading message displayed below the spinner. */
  message?: string;
  className?: string;
}

export function LoadingOverlay({ message, className }: LoadingOverlayProps) {
  return (
    <output className={overlayStyles({ className })} aria-live="polite">
      <div className="flex flex-col items-center gap-4">
        <div className={spinnerStyles()} />
        {message && <p className="text-sm font-medium text-muted-fg">{message}</p>}
        <span className="sr-only">{message ?? "Loading…"}</span>
      </div>
    </output>
  );
}
